var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-hold-or-not"},[(_vm.value === _vm.HOLD)?_c('div',{staticClass:"f-r-vc",staticStyle:{"gap":"2px"}},[_c('svg-icon',{staticClass:"svg-lock hold",attrs:{"icon-class":"lock"}}),_c('el-tag',{attrs:{"type":"warning","size":"small"}},[_vm._v("HOLD")])],1):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }